import { Discounts } from '@factorin/domain';

import { withUrl, list } from '../rest';


const discountsPart = withUrl('discounts');

export const discounts = {
    list: list<Discounts.DiscountItem>(discountsPart()).list,
};
